export const ENV = {
    tokenName: 'coop',
    eCodeName: 'findPw'
}